import React, { type HTMLAttributes } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Immutable from 'immutable';

import { Paragraph } from '@uncinc/react-drupal-core';
import { Container, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Hero, WysiwygField, SearchMaatjesProjects } from '../../../../components';
import { SCREEN_TABLET } from '../../../../config/constants';
import type { NodeHomePage as Type } from '../../../../types/uncinc_profile/nodes';

import './style.scss';

interface HomePageProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const NodeHomePageMaatjes: React.FC<HomePageProps> = ({
  entity,
  className,
}) => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const isMobile = width < SCREEN_TABLET;
  const classes = classNames(className, 'NodeHomePageMaatjes');
  const homePage = entity.toJS();
  const title = homePage.title[0].value;
  const body = homePage.body[0]?.processed;
  const paragraphs = homePage.field_paragraphs;
  const media = homePage.field_media_item[0];
  const { bundle } = media;
  let image = null;
  let videoMobile = null;
  let video = null;
  if (bundle === 'image') {
    image = media;
  } else if (bundle === 'video_file' && isMobile && media.entity.field_media_video_file_mobile.length > 0) {
    videoMobile = media.entity.field_media_video_file_mobile;
  } else {
    video = media;
  }

  return (
    // eslint-disable-next-line react/no-unknown-property
    <article typeof="schema:WebPage" className={classes}>
      <Hero
        image={image}
        video={video}
        mobileVideo={videoMobile ? videoMobile[0] : null}
        className="Hero__hero"
      >
        <div>
          <Container>
            <div className="Hero__hero__content">
              <div className="Hero__hero__content__text">
                {title && <h1 className="Hero__hero__content__text__title">{title}</h1>}
                {body && (
                  <WysiwygField
                    property="schema:text"
                    className="Hero__hero__content__text__body"
                    html={body}
                  />
                )}
              </div>
              <div className="Hero__hero__search">
                <p className="Hero__hero__search__label">
                  {t('maatjes.search.label')}
                </p>
                <div className="Hero__hero__search__content">
                  <SearchMaatjesProjects>
                    <SearchMaatjesProjects.SearchBar />
                  </SearchMaatjesProjects>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </Hero>

      <div className="Paragraphs NodeHomePageMaatjes__paragraphs">
        <Container>
          {paragraphs.length > 0 && paragraphs.map((paragraph) => {
            const targetId = paragraph.target_id;

            return (
              <Paragraph
                key={`paragraph:${targetId}`}
                id={targetId}
                entity={Immutable.fromJS(paragraph.entity)}
              />
            );
          })}
        </Container>
      </div>
    </article>
  );
};

export default NodeHomePageMaatjes;
